import React from 'react'
import SVG from 'react-inlinesvg'
import { HeaderContainer } from '../shared/elements'
import { logoutPath } from '../../utils/paths'

export default function Header(props) {
  return (
    <header>
      <HeaderContainer>
        <div className="logo">
          <SVG src="/images/logo-light.svg" width={180} />
        </div>
        <div className="control">
          <a href={logoutPath()} className="control-menu">
            <SVG src="/images/icons/logout.svg" width={20} />
            <span>Logout</span>
          </a>
        </div>
      </HeaderContainer>
    </header>
  )
}
